import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Logout = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Logout({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.21188 7.64645C7.40714 7.45118 7.72365 7.45118 7.91891 7.64645L8.27242 7.99996C8.46769 8.19522 8.46769 8.51173 8.27242 8.70699L5.66402 11.3154H13.2529C13.529 11.3154 13.7529 11.5393 13.7529 11.8154V12.3154C13.7529 12.5915 13.529 12.8154 13.2529 12.8154H5.66402L8.27242 15.4238C8.46768 15.619 8.46765 15.9356 8.27242 16.1308L7.91891 16.4853C7.72364 16.6801 7.40701 16.6803 7.21188 16.4853L3.14645 12.4189C2.95118 12.2236 2.95118 11.9071 3.14645 11.7119L7.21188 7.64645Z'
        fill={color}
      />
      <path
        d='M7.25 18.5C7.52614 18.5 7.74072 18.7326 7.84836 18.9869C8.0382 19.4353 8.48235 19.75 9 19.75H17.5C18.1904 19.75 18.75 19.1904 18.75 18.5V5.5C18.75 4.80964 18.1904 4.25 17.5 4.25H9C8.48235 4.25 8.0382 4.56465 7.84836 5.01313C7.74072 5.26743 7.52614 5.5 7.25 5.5H6.75C6.47386 5.5 6.24525 5.27416 6.29488 5.00252C6.529 3.72121 7.65108 2.75 9 2.75H17.5C19.0188 2.75 20.25 3.98122 20.25 5.5V18.5C20.25 20.0188 19.0188 21.25 17.5 21.25H9C7.65108 21.25 6.529 20.2788 6.29488 18.9975C6.24525 18.7258 6.47386 18.5 6.75 18.5H7.25Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'logout-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Logout;
